


class RevenueReport2Ctrl {
    getMonthName(month) {
        let d = new Date(2017, month - 1, 1);
        let name = this.dateFilter(d, 'MMMM');
        return name;
    }

    initializeMonths() {
        this.years = [];
        this.months = [];

        let date = new Date();
        for (let i = 2017; i <= date.getFullYear(); i++) {
            this.years.push(i);

            let first = i === 2017 ? 5 : 1;
            let last = i === date.getFullYear() ? date.getMonth() + 1 : 12;

            for (let j = first; j <= last; j++) {
                let name = this.getMonthName(j);
                let monthData = {
                    year: i,
                    month: j,
                    monthName: name
                };
                this.months.push(monthData);
            }

            this.filter = {
                year: date.getFullYear(),
                month: date.getMonth() + 1
            };
        }
    }

    loadData() {
        this.loading = true;
        this.errorMessage = null;
        this.successMessage = null;
        this.tableData = this.pageData = null;
        this.showPeriod = this.filter.all;

        let filterParams = Object.assign({}, this.filter);
        
        filterParams.all = String(this.filter.all !== undefined ? this.filter.all : false);
        
        for(let dateField of ['billingDate', 'dueDate', 'paymentDate']){
            let date = filterParams[dateField];
            if(!!date){
                date = moment(date).format('YYYY-MM-DD');
                filterParams[dateField] = date;
            }

            if(!date) {
                delete filterParams[dateField];
            }

        }

        filterParams.page = this.currentPage;
        filterParams.pageSize = this.pageSize;

        this.http({
            url: this.config.api + '/api/v1/reports/billing/data',
            params: filterParams,
            method: 'GET',
        }).then((res) => {
            this.loading = false;
            this.tableData = [];
            this.metadata = null;
            if (res.data && res.data.data) {
                this.tableData = res.data.data.data || [];
                this.metadata = res.data.data.metadata || {};
            }
            this.updatePageData();
        }, () => {
            this.loading = false;
            this.errorMessage = "Não foi possível carregar o relatório!";
        });
    }

    submitTable() {
        this.currentPage = 1;
        this.loadData();
    }

    submitExcel() {
        this.loading = true;
        this.tableData = this.pageData = null;
        this.errorMessage = null;
        this.successMessage = null;

        let filterParams = Object.assign({}, this.filter);
        
        filterParams.all = String(this.filter.all !== undefined ? this.filter.all : false);
        
        for(let dateField of ['billingDate', 'dueDate', 'paymentDate']){
            let date = filterParams[dateField];
            if(!!date){
                date = moment(date).format('YYYY-MM-DD');
                filterParams[dateField] = date;
            } 
            
            if(!date) {
                delete filterParams[dateField];
            }
        }

        this.http({
            url: this.config.api + '/api/v1/reports/billing/export',
            params: filterParams,
            method: 'GET',
            responseType: 'arraybuffer'
        }).then((res) => {
            this.loading = false;
            res.headers();
            var url = URL.createObjectURL(new Blob([res.data], { type: 'arraybuffer' }));
            var a = document.createElement('a');
            a.href = url;
            a.download = `RelatorioFinanceiro_${this.filter.month}-${this.filter.year}.csv`;
            a.target = '_blank';
            a.click();

            this.successMessage = "Relatório exportado com sucesso!";
        }, () => {
            this.loading = false;
            this.errorMessage = "Não foi possível gerar o relatório";
        });
    }

    submitChart() {
        this.chartsLoading = true;
        this.http({
            url: this.config.api + '/api/v1/reports/billing/charts',
            method: 'GET',
        }).then((res) => {
            this.chartData = res.data.data;

            this.generateNewVsCanceledChart();
            this.generateActiveSubsChart();
            this.chartsLoading = false;
        }, () => {

        });
    }

    generateActiveSubsChart() {
        let categories = [];
        let activeSubs = [];
        let revenue = [];

        for (let item of this.chartData.chartData) {
            categories.push(moment(item.period).format('MM/YYYY'));
            activeSubs.push(item.activeSubscriptions);
            revenue.push(Number(item.totalRevenue.toFixed(2)));
        }

        this.activeSubsChart = {
            title: {
                text: 'Total de Assinaturas Ativas'
            },
            xAxis: {
                categories: categories
            }, yAxis: [{
                name: 'Assinaturas Ativas',
                title: {
                    text: 'Assinaturas'
                }
            }, {
                title: {
                    text: 'Receitas'
                }, opposite: true
            }], series: [{
                colors: ['#FF9900', '#5CB1E6', '#A31717'],
                type: 'pie',
                name: 'Assinaturas por plano',
                data: this.chartData.plans.map(x => { return { y: x.count, name: x.planName }; }),
                center: [80, 0],
                size: 120,
                showInLegend: false,
                dataLabels: {
                    enabled: false
                }
            }, {
                name: 'Receita no Mês',
                type: 'column',
                yAxis: 1,
                data: revenue,
                tooltip: {
                    valuePrefix: 'R$ '
                }
            }, {
                type: 'line',
                yAxis: 0,
                name: 'Assinaturas ativas',
                data: activeSubs
            }]
        };
        this.timeout(() => {
            Highcharts.chart('chart2', this.activeSubsChart);
        }, 100);


        this.revenueChart = {
            title: {
                text: 'Receita Mensal'
            },
            xAxis: {
                categories: categories
            }, yAxis: {
                name: 'Receita Mensal',
                title: {
                    text: 'Receita'
                }
            }, series: [{
                name: 'Receita no Mês',
                type: 'column',
                yAxis: 0,
                data: revenue,
                tooltip: {
                    valuePrefix: 'R$ '
                }
            }]
        };

    }

    generateNewVsCanceledChart() {

        let categories = [];
        let newSeries = [];
        let canceledSeries = [];

        for (let item of this.chartData.chartData) {
            categories.push(moment(item.period).format('MM/YYYY'));
            newSeries.push(item.newSubscriptions);
            canceledSeries.push(item.canceledSubscriptions);
        }

        this.newVsCanceledChart = {
            colors: ['#5ead5d', '#e55430'],
            chart: {
                type: 'line'
            },
            title: {
                text: 'Novas Assinaturas x Cancelamentos'
            },
            xAxis: {
                categories: categories,
                title: {
                    text: 'Meses'
                }
            },
            yAxis: {
                min: 0,
                title: {
                    text: 'Assinaturas'
                }
            },
            tooltip: {},
            plotOptions: {
                bar: {
                    dataLabels: {
                        enabled: true
                    }
                }
            },
            series: [{
                type: 'column',
                name: 'Novas Assinaturas',
                data: newSeries
            }, {
                type: 'column',
                name: 'Assinaturas Canceladas',
                data: canceledSeries
            }]
        };

    }

    initializeStatusTypes() {
        this.statusTypes = [{
            label: 'todos',
            value: 'ALL'
        }, {
            label: 'cobranças no mês',
            value: 'CHARGED'
        }, {
            label: 'pagos',
            value: 'PAID'
        }, {
            label: 'pendentes',
            value: 'PENDING'
        }];

        this.filter.status = 'PAID';
    }

    initializeSubscriptionTypes() {
        this.subscriptionTypes = [{
            label: 'novas assinaturas no período',
            field: 'newSubscriptions'
        }, {
            label: 'novas assinaturas desde o lançamento',
            field: 'newSinceLaunch'
        }, {
            label: 'assinaturas canceladas no período',
            field: 'canceled'
        }];
    }

    initializePagination() {
        this.currentPage = 1;
        this.pageSize = 50;
        this.metadata = null;
    }

    changePage(newPage) {
        this.currentPage = newPage;
        this.loadData();
    }
    updatePageData() {
        this.pageData = this.tableData;
        if (this.metadata) {
            this.pageStart = (this.metadata.page - 1) * this.metadata.limit + 1;
            this.pageEnd = Math.min(this.pageStart + this.pageData.length - 1, this.metadata.total);
        } else {
            this.pageStart = 0;
            this.pageEnd = this.tableData.length;
        }
    }

    constructor($filter, $http, $timeout, config) {
        this.timeout = $timeout;
        this.dateFilter = $filter('date');
        this.http = $http;
        this.config = config;
        this.initializeMonths();
        this.initializeStatusTypes();
        this.initializeSubscriptionTypes();
        this.initializePagination();

        this.submitChart();
    }



}

angular.module('admin.reports').controller('RevenueReport2Ctrl', RevenueReport2Ctrl);